var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0004 12.2105C22.0004 11.4295 21.9357 10.8596 21.7958 10.2686H12.6953V13.7937H18.0371C17.9294 14.6697 17.3479 15.989 16.0555 16.8756L16.0373 16.9936L18.9147 19.1781L19.1141 19.1976C20.9449 17.5405 22.0004 15.1024 22.0004 12.2105Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.698 21.5002C15.315 21.5002 17.512 20.6558 19.1167 19.1994L16.0581 16.8773C15.2396 17.4367 14.1411 17.8272 12.698 17.8272C10.1348 17.8272 7.95931 16.1702 7.18382 13.8799L7.07015 13.8893L4.07819 16.1586L4.03906 16.2652C5.63297 19.3682 8.90699 21.5002 12.698 21.5002Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17864 13.8793C6.97402 13.2883 6.85559 12.655 6.85559 12.0007C6.85559 11.3462 6.97402 10.713 7.16787 10.122L7.16245 9.99608L4.13299 7.69043L4.03388 7.73663C3.37695 9.02429 3 10.4703 3 12.0007C3 13.531 3.37695 14.9769 4.03388 16.2646L7.17864 13.8793Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.698 6.17389C14.5181 6.17389 15.7458 6.94435 16.4459 7.58822L19.1814 4.97071C17.5014 3.44032 15.3151 2.50098 12.698 2.50098C8.90701 2.50098 5.63298 4.63295 4.03906 7.73592L7.17307 10.1212C7.95934 7.83095 10.1348 6.17389 12.698 6.17389Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.f9af405cc3c42724781a9d78e7bbb642.svg";
export { ForwardRef as ReactComponent };